/* Isolated desktop disclosure navigation. No changes to header-drawer. */
if (!customElements.get('tm-desktop-nav')) {
  customElements.define('tm-desktop-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.entries = [...this.querySelectorAll('.tm-nav__details')];
      this.openTimer = null;
      this.closeTimer = null;
      this.entries.forEach(entry => {
        const trigger = entry.querySelector('summary');
        entry.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.cancelTimers();
          this.openTimer = setTimeout(() => this.show(entry), 140);
        }, opts);
        entry.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.cancelTimers();
          if (!entry.contains(document.activeElement)) this.closeTimer = setTimeout(() => this.close(entry), 280);
        }, opts);
        trigger.addEventListener('click', event => {
          event.preventDefault();
          this.cancelTimers();
          entry.open ? this.close(entry) : this.show(entry);
        }, opts);
        trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault(); this.show(entry);
            entry.querySelector('.tm-nav__panel a')?.focus();
          }
        }, opts);
        entry.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(entry.open)), opts);
        entry.addEventListener('focusout', event => {
          if (!entry.contains(event.relatedTarget)) { this.cancelTimers(); this.close(entry); }
        }, opts);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const entry = this.entries.find(item => item.open);
          if (entry) { event.preventDefault(); this.cancelTimers(); this.close(entry); entry.querySelector('summary').focus(); }
        }
      }, opts);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) { this.cancelTimers(); this.entries.forEach(entry => this.close(entry)); }
      }, opts);
      window.addEventListener('resize', () => {
        this.cancelTimers(); this.entries.forEach(entry => this.close(entry));
      }, opts);
      window.addEventListener('scroll', () => {
        if (this.entries.some(entry => entry.open)) this.position();
      }, { ...opts, passive: true });
    }
    position() {
      const row = this.closest('.header__row') || this;
      const bottom = Math.max(0, row.getBoundingClientRect().bottom);
      this.style.setProperty('--tm-nav-top', `${bottom}px`);
      this.style.setProperty('--tm-nav-max-height', `${Math.max(120, window.innerHeight - bottom - 20)}px`);
    }
    show(entry) {
      this.position();
      this.entries.forEach(other => { if (other !== entry) this.close(other); });
      entry.open = true;
      entry.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
    close(entry) {
      entry.open = false;
      entry.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
    cancelTimers() { clearTimeout(this.openTimer); clearTimeout(this.closeTimer); }
    disconnectedCallback() { this.cancelTimers(); this.abort?.abort(); }
  });
}
